import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Назад ")

import { computed } from "vue"

import LeftArrowIcon from "@layout/assets/icons/left-arrow-icon.vue"
import { BaseButton } from "@layout/components"
import { useRouter } from "vue-router"
import { PATHS } from "@global/utils/PATHS"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const currentRoute = computed(() => router.currentRoute.value)

const isShowBackButton = computed(
  () => currentRoute.value.name !== PATHS.home.name
)

const goBack = () => {
  const {
    meta: { pageToGoBackwards },
    params: { customisedWayBackName },
  } = currentRoute.value

  if (customisedWayBackName && customisedWayBackName !== "null") {
    router.push({ name: customisedWayBackName.toString() })
    return
  }

  if (pageToGoBackwards) {
    router.push({ name: pageToGoBackwards.name })
    return
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(isShowBackButton))
    ? (_openBlock(), _createBlock(_unref(BaseButton), {
        key: 0,
        class: "nav-link",
        "btn-type": "empty",
        onClick: _cache[0] || (_cache[0] = () => goBack())
      }, {
        default: _withCtx(() => [
          _createVNode(LeftArrowIcon, { class: "nav-icon" }),
          _hoisted_1
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})